
// This section has been split into UserInfluencersSection and UserBrandsSection.
// Please use those components/pages for user management.

const UsersSection: React.FC = () => (
  <div className="p-8 text-center text-gray-500">
    <h2 className="text-2xl font-bold mb-4">Users Section Deprecated</h2>
    <p>
      Please use <b>User Influencers</b> and <b>User Brands</b> sections from the sidebar for user management.
    </p>
  </div>
);

export default UsersSection;
